import { isAxiosError } from "axios"

/** A request the server refused (4xx): asking again gets the same answer. */
export const isRefusedRequest = (error: unknown): boolean => {
  const status = isAxiosError(error) ? error.response?.status : undefined
  return status !== undefined && status >= 400 && status < 500
}
